import React from 'react';
import { CartoonPortrait } from './CartoonPortrait';
interface FigureProps {
  className?: string;
}
export function FirstbornFigure({
  className = ''
}: FigureProps) {
  return <CartoonPortrait className={className} label="Cartoon portrait of a neat, composed firstborn" disc="#2E7FB8" skin="#F2C49B" skinShade="#E0A97C" hair="#2A2118" shirt="#FBF7F0" hairStyle="sideParted" mouth="closed" motif="glasses" data-id="element-69" data-mp="r81o5xj8bs7m" />;
}